module.exports = __webpack_public_path__ + "static/me-f5f92c891d24e117fc3c1f125006a785.jpg";